import { msg } from "@lingui/core/macro";

export const contactDuplicateExistsMessage = msg`A contact with these exact details already exists.`;
export const customerEmailAlreadyExistsMessage = msg`A customer with this email already exists`;
export const customerEmailLockedByParkerAccountMessage = msg`This customer's email can't be edited because a parker account is connected.`;
export const customerExternalIdAlreadyExistsMessage = msg`A customer with this external ID already exists`;
export const defaultFieldNameMessage = msg`Cannot add ''{Notes}'' - this field already exists by default`;
export const duplicateNameMessage = msg`This field label already exists. Please use a unique label`;
export const duplicatePermissionMessage = msg`Duplicate permission for the same entity`;
export const emailAlreadyExistsMessage = msg`Email already exists`;
export const hubConfigIncompleteMessage = msg`HUB integration config is missing one or more required fields: baseUrl, bookingCompanyReferenceId, bookingCompanyReferenceName, username, password`;
export const hubInternalNameChangeMessage = msg`HUB integration internal name cannot be changed`;
export const hubInternalNameLockedMessage = msg`HUB integration internal name must be HUB or HUBTEST`;
export const identifierAlreadyExistsMessage = msg`Identifier already exists`;
export const invalidPhoneNumberMessage = msg`Invalid Phone Number`;
export const invalidTimezoneMessage = msg`Invalid Timezone`;
export const locationNameAlreadyExistsMessage = msg`Location name already exists`;
export const nameAlreadyExistsMessage = msg`Name already exists`;
export const numbersOnlyMessage = msg`Only numbers allowed`;
export const oneIntegrationTypePerCompanyMessage = msg`Only one integration type per company is allowed`;
export const oneInternalNamePerTypePerCompanyMessage = msg`Integration with this name already exists on this company`;
export const paymentConnectionMessage = msg`There was an issue connecting to your payment provider. Please try again or contact support.`;
export const paymentPeriodChangedWhileEditingMessage = msg`This pay period changed while you were editing. Reload and try again`;
export const paymentPeriodCollectionWindowMessage = msg`Moving this pay period would change the deductions for the {permitType} rate`;
export const paymentPeriodDuplicateEditMessage = msg`Each pay period can only be edited once`;
export const paymentPeriodEndBeforeStartMessage = msg`The end date cannot be before the start date`;
export const paymentPeriodMustFollowScheduleMessage = msg`New pay periods must start after the last pay period on the schedule`;
export const paymentPeriodNotOnScheduleMessage = msg`This pay period is not on the schedule`;
export const paymentPeriodOrderMessage = msg`Pay periods must keep their original order`;
export const paymentPeriodOverlapMessage = msg`Pay periods cannot overlap`;
export const paymentPeriodProcessedMessage = msg`Pay periods that have started or already have a payroll report cannot be edited`;
export const paymentPeriodReportGeneratedMessage = msg`A payroll report has already been generated for this pay period`;
export const paymentPeriodReportRunningMessage = msg`A payroll report for this pay period is being generated right now. Try again in a few minutes`;
export const paymentPeriodStartMustBeFutureMessage = msg`The new start date must be in the future`;
export const paymentScheduleArchivedMessage = msg`Archived payment schedules cannot be edited`;
export const payrollNameRequiredMessage = msg`A payroll name is required when linking a payroll integration`;
export const permitActiveCannotBeCancelledMessage = msg({
	comment:
		"Shown to a parker who tries to cancel a permit that started (and became active) after the page was loaded. Distinct from the expired and payment-session variants below.",
	message: "This permit is now active and can no longer be cancelled. Please contact the administrator.",
});
export const permitExpiredCannotBeCancelledMessage = msg({
	comment:
		"Shown to a parker who tries to cancel a permit that already ended. Distinct from the active and payment-session variants.",
	message: "This permit has expired and can no longer be cancelled.",
});
export const permitHasPaymentSessionCannotBeCancelledMessage = msg({
	comment:
		"Shown to a parker who tries to cancel a permit that has a payment session (paid, pending, or failed) — an admin must handle the payment or refund manually. Distinct from the active and expired variants.",
	message: "This permit can't be cancelled automatically. Please contact the administrator.",
});
export const permitLastVehicleCannotBeRemovedMessage = msg({
	comment:
		"Error in the parker portal's Edit Vehicles dialog when saving would leave the permit with no vehicles, e.g. the other vehicles were already removed in another browser tab.",
	message: "Your permit needs at least one vehicle.",
});
export const permitNotFoundMessage = msg`We couldn't find a permit or registration using that confirmation number`;
export const permitRequestCannotBeApprovedMessage = msg({
	comment:
		"Error in the dashboard approve dialog when the permit request was already decided, e.g. by another admin in a different tab.",
	message: "This request can no longer be approved. Refresh the page to see its current status.",
});
export const permitRequestCannotBeRejectedMessage = msg({
	comment:
		"Error in the dashboard reject dialog when the permit request was already decided, e.g. by another admin in a different tab.",
	message: "This request can no longer be rejected. Refresh the page to see its current status.",
});
export const permitRequestParkingOptionNotOfferedMessage = msg({
	comment: "Error when approving a permit request with a parking option that is not part of its permit type.",
	message: "The selected parking option isn't offered by this permit type.",
});
export const permitRequestRequesterNotInSegmentMessage = msg({
	comment:
		"Error in the dashboard approve dialog when the applicant is not in any customer segment allowed to hold the permit type.",
	message: "The applicant isn't in a segment that can hold this permit type.",
});
export const permitTypeDashboardDisabledMessage = msg`Permits cannot be created from the dashboard for this permit type`;
export const permitTypeDraftNotPublishedMessage = msg({
	comment:
		"Validation error when an operator tries to create a permit against a permit type that is still an unpublished draft. Distinct from the dashboard-disabled message: dashboard creation may well be enabled, the type just isn't live yet.",
	message: "This permit type is still a draft. Publish it before creating permits.",
});
export const permitTypeDayNightEndDateMessage = msg`Day and night pricing needs an end date on every parking window`;
export const permitTypeLastPortalLinkMessage = msg({
	comment:
		"Error when an operator deletes the last direct Permit Type portal link of a Permit Type that overrides others. An override makes one Permit Type disable another when their schedules overlap, and the portal sends guests to the overriding Permit Type through that link.",
	message:
		"At least one Permit Type link that isn't in Kiosk Mode is required while Overrides and Portal Access are enabled. This ensures guests can register for this permit when schedules overlap.",
});
export const permitTypeLocationNotAssociatedWithTenantMessage = msg`One or more selected locations aren't associated with this permit type's tenant(s). Associate them with the tenant first, or remove them before saving.`;
export const permitTypeNightlyScheduleMessage = msg`Nightly pricing is not supported on a parking option with a schedule`;
export const permitTypeOverrideAlreadyOverriddenMessage = msg({
	comment:
		"Validation error on the permit type Parking form. An override makes one Permit Type disable another when their schedules overlap; a Permit Type may sit on only one side of that relationship, never both.",
	message: "A permit type that is already overridden cannot override other permit types",
});
export const permitTypeOverrideAlreadyOverridesMessage = msg({
	comment:
		"Validation error on the permit type Parking form. Mirror of the 'already overridden' error: the Permit Type the operator picked to disable is itself already disabling others.",
	message: "A permit type that already overrides others cannot be overridden",
});
export const permitTypeOverrideEventNotAllowedMessage = msg({
	comment:
		"Validation error on the permit type Parking form. 'Events' are event Permit Types, a distinct product entity that is excluded from override relationships entirely.",
	message: "Events cannot participate in overrides",
});
export const permitTypeOverrideRequiresConcreteTimesMessage = msg({
	comment:
		"Validation error on the permit type Parking form. Only parking options configured with fixed intervals (explicit start and end date-times) can override other permit types.",
	message: "Overriding permit types must use fixed parking intervals with an end",
});
export const permitTypeOverrideSelfMessage = msg({
	comment:
		"Validation error on the permit type Parking form, shown when the operator's selection includes the Permit Type currently being edited or one of its own parking options.",
	message: "A permit type cannot override itself",
});
export const permitTypeOverrideTargetsNotFoundMessage = msg({
	comment:
		"Validation error on the permit type Parking form. The selected Permit Types could not be loaded because they no longer exist, were deleted, or belong to a different company.",
	message: "One or more overridden permit types were not found",
});
export const permitTypeNoExpiryBoundedWindowMessage = msg({
	comment:
		"Validation error on the permit type Parking form. Never Expires means Permits stay valid indefinitely, so the parking option cannot also have a fixed parking window that ends.",
	message: "A parking option with Never Expires cannot have a parking window with an end date",
});
export const permitTypeNoExpiryConflictMessage = msg({
	comment:
		"Validation error on the permit type Parking form. Never Expires means Permits stay valid indefinitely, so the parking option cannot also set when or how long after starting a Permit ends.",
	message: "A parking option with Never Expires cannot have other expiry or duration rules",
});
export const permitTypeParkingOptionLocationRequiredMessage = msg({
	comment:
		"Validation error when saving any section of a permit type or event while one of its parking options has no locations, e.g. its only location was removed. {name} is the parking option's name, such as 'Option 1'. 'Parking' is the name of the section where locations are chosen.",
	message: "Add at least one location to {name} in the Parking section",
});
export const permitTypeRateTableEndDateMessage = msg({
	comment:
		"Validation error on the permit type pricing form. A rate table charges by day of week and time of day, so a parking option priced by one must have an end date on every parking window.",
	message: "Rate table pricing needs an end date on every parking window",
});
export const permitEndDateRequiredMessage = msg({
	comment:
		"Error when creating or buying a permit with no end (Never Expires). The parking option's price depends on how long the permit lasts, so the permit must have an end date and time. Shown to operators and parkers.",
	message: "This parking option needs an end date and time",
});
export const permitTypeRateTableWithFixedRatesMessage = msg({
	comment:
		"Validation error on the permit type pricing form. A rate table (prices by day of week and time of day) and fixed rates are two alternative ways to price one parking option; an option may use only one.",
	message: "A parking option is priced by either fixed rates or a rate table, not both",
});
export const permitVehicleAlreadyRemovedMessage = msg({
	comment:
		"Error in the parker portal's Edit Vehicles dialog when the parker removes a vehicle that was already removed from the permit, e.g. in another browser tab.",
	message: "This vehicle was already removed from your permit.",
});
export const retroactiveCollapseLocationRequiredMessage = msg`Choose the location existing permits should use`;
export const retroactiveOptionStaleMessage = msg`This option no longer has a pending change; reload and try again`;
export const retroactiveUpdateInProgressMessage = msg`An earlier update to this permit type is still being applied; wait for it to finish`;
export const vehicleAlreadyExistsMessage = msg`Please enter unique vehicles.`;
export const vehiclePlateInvalidMessage = msg`Please enter a valid license plate (up to 10 characters)`;
export const vehiclePlateRequiredMessage = msg`License plate is required`;
